<!--CONTENIDO ITEM DATOS DEMANDANTE-->
<ng-container>
  <div class="wrapper__form">
    <app-form
      [title]="' '"
      [fields]="formFieldsTipoPersona"
      [withSubmitButton]="false"
      (changeAction)="validarFormularioTipoPersona($event)"
      [idEntidad]="entidadId" />
    <br />

    <app-form
      [fields]="formFieldsDemandanteNatural"
      *ngIf="formTipoPersona.value?.tipoPersona === '1' && mostrarFormulario"
      [title]="comunText['demandante-natural']"
      [withSubmitButton]="false"
      (changeAction)="validarFormularioDemandante($event)"
      (changedControl)="onChangeValidarFormulario($event)"
      [idEntidad]="entidadId" />

    <app-form
      [fields]="formFieldsDemandanteJuridic"
      *ngIf="formTipoPersona.value?.tipoPersona === '2' && mostrarFormulario"
      [title]="comunText['demandante-juridico']"
      [withSubmitButton]="false"
      (changeAction)="validarFormularioDemandante($event)"
      (changedControl)="onChangeValidarFormulario($event)"
      [idEntidad]="entidadId" />

    <div *ngIf="mensajeErrorDemandante.length > 0" class="invalid-feedback mt-5">
      {{ mensajeErrorDemandante }}
    </div>

    <app-form
      *ngIf="
        formTipoPersona.value?.tipoPersona === '1' ||
        formTipoPersona.value?.tipoPersona === '2'
      "
      [fields]="formFieldsMedios"
      [title]="''"
      [withSubmitButton]="false"
      (changeAction)="validarFormularioMedios($event)"
      [idEntidad]="entidadId" />

    <div class="d-flex flex-wrap justify-content-end gap-2 mt-md-5 mt-3">
      <button
        *ngIf="indexEditarDemandante !== undefined"
        type="submit"
        class="btn-govco fill-btn-danger-govco mt-3 ms-2"
        (click)="cancelarEditarDemandante()"
        aria-label="Cancelar edición">
        {{ proconText['cancelar'] }}
      </button>
      <button
        type="submit"
        class="btn-govco fill-add-govco mt-3 ms-2"
        [disabled]="validAddDemandante()"
        (click)="agregarDemandante(indexEditarDemandante)"
        aria-label="Guardar demandante">
        {{ proconText['tramite-sic-comp-desleal']['guardar-demandante'] }}
      </button>
    </div>

    <app-table
      [estiloEncabezado]="'height: auto !important;'"
      *ngIf="dataTableNatural.length > 0"
      id="tblDemandanteNatural"
      [acciones]="actions"
      (eventoAccion)="accionesDemandante($event)"
      [datos]="dataTableNatural"
      [columnas]="columnsNatural"
      [paginacion]="false" />
    <br />
    <app-table
      [estiloEncabezado]="'height: auto !important;'"
      *ngIf="dataTableJuridic.length > 0"
      id="tblDemandanteJuridic"
      [acciones]="actions"
      (eventoAccion)="accionesDemandante($event)"
      [datos]="dataTableJuridic"
      [columnas]="columnsJuridica"
      [paginacion]="false" />
    <br />

    <app-form
      [title]="proconText['tramite-sic-procon']['apoderado-judicial']"
      [fields]="formFieldsTieneApoderado"
      [withSubmitButton]="false"
      (changeAction)="validarFormularioTieneApoderado($event)"
      [idEntidad]="entidadId" />
    <br />

    
      <app-cargue-archivos-tramite
        *ngIf="mostrarArchivos"
        [idTipoTramite]="Constants.SIC_PROCON"
        [paso]="1"
        [idTramite]="tramiteSic?.id??0"
        (archivosObligatoriosPasos)="validarArchivosRequeridos($event)"
        (archivosCargados)="validarArchivosCargados($event)"
        [enviar]="guardarArchivos"
        (guardo)="subirArchivo($event)"
        [archivosPreCargados]="archivosPrecargados"
        [reglaRequerido]="JSON.stringify({apoderado:'SI'})"
        [codigoPretencion]="JSON.stringify({apoderado:'SI'})">
      </app-cargue-archivos-tramite>
      <!-- <app-cargue-archivos-tramite
        *ngIf="archivosPrecargados.length == 0"
        [idTipoTramite]="Constants.SIC_PROCON"
        [paso]="1"
        [idTramite]="tramiteSic?.id??0"
        (archivosObligatoriosPasos)="validarArchivosRequeridos($event)"
        (archivosCargados)="validarArchivosCargados($event)"
        [enviar]="guardarArchivos"
        (guardo)="subirArchivo($event)"
        [archivosPreCargados]="archivosPrecargados"
        [reglaRequerido]="JSON.stringify({apoderado:'SI'})"
        [codigoPretencion]="JSON.stringify({apoderado:'SI'})">
      </app-cargue-archivos-tramite> -->
    <div *ngIf="formTieneApoderado.value?.attorney === Constants.VALOR_S"> 
      <div class="mt-3 text-muted small d-flex align-items-center" *ngIf="archivosCargadosPasoUno.length > 0">
        <i class="bi bi-info-circle me-2"></i>
        {{ 'copia_envio.peso_actual' | translate:{ peso: pesoArchivos } }}
      </div>
    </div>
    <br/>
    <app-form
      [fields]="formFieldsApoderado"
      *ngIf="formTieneApoderado.value?.attorney === 'S'"
      [withSubmitButton]="false"
      (changeAction)="validarFormularioApoderado($event)"
      (changedControl)="onChangeValidarFormulario($event)"
      [idEntidad]="entidadId" />
  </div>

  <div class="col-12 col-md-12 py-3 d-flex justify-content-end">
    <div class="d-flex flex-column flex-md-row gap-2">
      <button
        type="button"
        class="btn-govco fill-btn-govco  w-auto"
        
        (click)="pasarADemandado($event, true)"
        aria-label="Guardar sin enviar">
        {{ proconText['botones-envio']['guardar-sin-enviar'] }}
      </button>
      <button
        type="submit"
        class="btn-govco fill-next-btn-govco btn-form w-auto"
        (click)="onClickSiguiente($event)"
        aria-label="Siguiente">
        {{ proconText['siguiente'] }}
      </button>
    </div>
    <!--[disabled]="habilitarBoton()"-->
  </div>
</ng-container>
